'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:core:OSVersion');
}

var _invoke = require('../invoke');

/**
 * 获取桥协议版本
 *
 * 支持版本
 * + iHotel/6.1+
 * + HBNB/?
 *
 * @memberof core
 * @static
 * @name OS
 * @return {Promise<version>}
 * @example
 *  hbnb.core.OSVersion()
 *      .then(function(version) {
 *          version = {
 *              os: 'ios',
 *              version: '9.0'
 *          }
 *      });
 */

module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('called');
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('core', 'os_version', {
            callback: function(version) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('version is %j', version);
                }
                resolve(version);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/core/os_version.js
// module id = 237
// module chunks = 4